import { Menu as MenuMantine } from "@mantine/core";

export const MenuDropdown = MenuMantine.Dropdown;
